import { useEffect, useRef, useState } from 'react';

const AutoplayPlayer = ({ src }) => {
 const audioRef = useRef(null);
 useEffect(() => {
    const sound = new Audio(src);
    
    const playSound = async () => {
      try {
        await sound.play();
      } catch (err) {
        // Handle blocked autoplay by playing on first user gesture
        const unlock = () => {
          sound.play();
          window.removeEventListener('mousedown', unlock);
        };
        window.addEventListener('mousedown', unlock);
      }
    };

    playSound();

    // Cleanup: Stop sound and clear memory
    return () => {
      sound.pause();
      sound.src = "";
    };
  }, [src]);

  return null; // Stays completely invisible in the DOM
};

export default AutoplayPlayer;